module.exports = __webpack_public_path__ + "static/media/step3-poster.0db04e69.png";